import React from 'react'
import "../../styles/s_machine.css"
import Prodcard1 from '../../components/prodcards/Prodcard'
import img7 from '../../img/SealerM/SAwswst_7.jpeg'
import img75 from '../../img/SealerM/shrinkT .png'
import img8 from '../../img/SealerM/8.jpg'
import img27 from '../../img/SealerM/27.jpeg'
import img9 from '../../img/SealerM/9.jpeg'
import img28 from '../../img/SealerM/28.png'
import img21 from '../../img/SealerM/21.png'
import img32 from '../../img/SealerM/32.png'
import img34 from '../../img/SealerM/34.png'
import imgFpsM  from '../../img/SealerM/FPsm.jpeg'

export const SealerM = () => {
  const des = {
    sam: ['mode -101H', 'Max Strap Size -Notstipulte', 'Min Strap Size 60*30', 'Strapping Speed - 1.5', 'Strap Width - 6-15', 'Strap Force - 450', 'Dimension - 900*580*750/500'],
    img75: ['voltage - 220/50 -380/50', 'power - 3.3-12.5', 'conveyor loading - 5-30', 'speed - 0~6-0~10', 'heating time - 5-10', 'cooling time - 15', 'weight - 40-150', '*Height Adjustable'],
    img32: ['AUTOMATION GRADE - MANUAL', 'SEALING LENGTH - 24INCH', 'MATERIAL - METAL', 'POWER - 600W', 'COLOR - ORANGE', 'ORIENTATION - HORIZONTAL', 'VOLTAGE - 240V', 'SEALIING WIDTH -2MM', 'WEIGHT - 4.9KG',
    ],
    img34: ['Power Supply - 220v/50w', 'Sealing Diameter - 5-80mm', 'Processing Height - 0-200', 'Sealing Speed - 20 Times', 'Frequency - 20khz', 'machine size - 850*460*450', 'Weight -80'],
    img21: ['Capacity - 500 Pouch/Hour', 'Automation Grade - Manual', 'Voltage - 220V', 'Weight - 8KG', 'Width - 152MM', 'Power - 2 & 3 Phase', 'Heater Plate - 10 Min', 'Material - Aluminium'],
    img28: ['Sealing Size - W450 /', 'Power - 1.40/11.7', 'Voltage - 220V-380V/50-60Hz', 'Thickness Of Film - 0.015-0.10', 'Capacity - 0-35pcs/0-12pcs', 'Air Pressure - 5', 'Weight - 340/260', 'Packing Material - POF PVC',
    ],
    img27: ['Voltage - 220V/50-60Hz - Single Phase', ' Power - 1.3Kw', 'Capacity - 0-20packs', ' File Size - W600mm', 'Air Compressor - 0.3mmm', 'Dimension - 1700*900*1400mm', 'Weight - 320Kg', 'Sealing Size - 500*350*100mm',
    ],
    img7: ['voltage-300/50 - 380/50 3 phase', 'power consumption-1.5/21', 'packing speed-0~12/0~10', 'max sealing length-650', ' height of conveyor-800+50(adjustable)', 'air pressure-6', 'conveyor loading- 40', 'heating time-10', 'cooling time 15', 'weight - 300',
    ],
    img8: ['voltage - 220/50 ', 'power - 4.5', 'conveyor loading - 10', 'speed - 0~10', 'heating time - 10', 'cooling time - 15', 'weight - 70', '*Height Adjustable',
    ],
    img9:['VOLTAGE-220/50','MAX CARTON SIZE-500*500',' MIN CARTON SIZE-80-90','SPEED-20','HEIGHT-580*780',' WIDTH-36*48','SIZE-1750*880(1300-1500)','WEIGHT-120','AIR COMPRESSOR-NA','POWER-200',
      ],
    imgFpsM:['SEALING LENGTH-350-800','SEALING WIDTH-5','INPUT VOLTAGE-220/50','HEATING TIME-0~2.5','IMPULSE POWER-1200-1800','CASE SIZE-450*540*880-855*570*880','WEIGHT-19-29',
      ]  
  }
  return (
    <div className='prdmain'>
      <div className='head2'>
        <h1>Sealer Machine</h1>
      </div>
      <div className='items1'>
        <Prodcard1
          imageSrc={img7}
          model={"VP 6540/5540L"}
          title="Semi Automatic web sealer with shrink tunnel "
          altText="img of websit"
          description={des.img7}
        />
        <Prodcard1
          imageSrc={img75}
          model={"VPS 3020/4525/4535/6535"}
          title="shrink tunnel"
          altText="img of websit"
          description={des.img75}
        />
        <Prodcard1
          imageSrc={img8}
          model={"VPS 3020"}
          title="table top mini shrink tunnel"
          altText="img of websit"
          description={des.img8}
        />
        <Prodcard1
          imageSrc={img27}
          model={"VP 5545A"}
          title="Automatic L-seale"
          altText="img of websit"
          description={des.img27}
        />
        <Prodcard1
          imageSrc={img9}
          model={"VP 102 TU"}
          title="Carton Sealer"
          altText="img of websit"
          description={des.sam}
        />
        <Prodcard1
          imageSrc={img28}
          model={"VP 4520L/VP SL4518 "}
          title="Automatic side sealing machine"
          altText="img of websit"
          description={des.img28}
        />
        <Prodcard1
          imageSrc={img21}
          model={"VP Foil sealing  "}
          title="Foil sealing machine"
          altText="img of websit"
          description={des.img21}
        />
        <Prodcard1
          imageSrc={img32}
          model={"VP 8-24 INCH"}
          title="Hand sealing machine"
          altText="img of websit"
          description={des.img32}
        />
        <Prodcard1
          imageSrc={img34}
          model={"VP UTS"}
          title="ultra sonic tube sealing machine"
          altText="img of websit"
          description={des.img34}
        />
         <Prodcard1
          imageSrc={imgFpsM}
          model={"VPFPS 350-800"}
          title="FOOT PEDAL SEALING MACHINE"
          altText="img of websit"
          description={des.imgFpsM}
        />
      </div>


    </div>
  )
}
